import { render, staticRenderFns } from "./LglComplaintsReport.vue?vue&type=template&id=b8047cfc&"
import script from "./LglComplaintsReport.vue?vue&type=script&lang=js&"
export * from "./LglComplaintsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports